import { z } from 'zod';

const verificationReasonSchema = z.string().trim().min(5, 'Reason must be at least 5 characters');

/** Admin approves a submitted vendor (SUBMITTED → APPROVED) or reinstates (SUSPENDED → APPROVED). */
export const AdminApproveVendorVerificationSchema = z.object({
  notes: z.string().max(2000).optional(),
});

/**
 * Shared body for admin actions that require a decision reason.
 * `reason` → vendor-facing verificationReason + audit; `notes` → optional internal admin context.
 */
export const AdminVendorVerificationReasonBodySchema = z.object({
  reason: verificationReasonSchema,
  notes: z.string().max(2000).optional(),
});

/** Admin rejects a submitted vendor (SUBMITTED → REJECTED). */
export const AdminRejectVendorVerificationSchema = AdminVendorVerificationReasonBodySchema;

/** Admin suspends an approved vendor (APPROVED → SUSPENDED). */
export const AdminSuspendVendorVerificationSchema = AdminVendorVerificationReasonBodySchema;
